module.exports = __webpack_public_path__ + "static/media/Gallery-5.d82cc338.jpg";